<div class="canvas-container">
    <ng-container *ngIf="isLoading; else content">
        <div class="spinner-overlay">
            <mat-spinner diameter="50"></mat-spinner>
        </div>
    </ng-container>

    <canvas #canvas></canvas>

    <ng-template #content>
        <div class="drag-to-spin">
            <mat-icon>touch_app</mat-icon>
            <span>Drag to Spin</span>
        </div>

        <div class="zoom-buttons">
            <button class="zoom-btn" (click)="zoom(zoomConfig.zoomIn)">+</button>
            <button class="zoom-btn" (click)="zoom(zoomConfig.zoomOut)">-</button>
        </div>
    </ng-template>
</div>
